import React, { useEffect, useState } from "react";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import {
  postData,
  getData,
  deleteData,
  putData,
} from "../../../services/FetchNodeservices";

export default function Branch() {
  const [branches, setBranches] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const [form, setForm] = useState({
    id: null,
    branch_name: "",
    telephone_number: "",
    mobile_number: "",
    email: "",
    remarks: "",
  });

  /* ================= FETCH ================= */
  const fetchBranches = async () => {
    const res = await getData("branch/fetch");
    if (res?.status) setBranches(res.data);
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  /* ================= MODALS ================= */
  const openAddModal = () => {
    setForm({
      id: null,
      branch_name: "",
      telephone_number: "",
      mobile_number: "",
      email: "",
      remarks: "",
    });
    setModalOpen(true);
  };

  const openEditModal = (branch) => {
    setForm({
      id: branch.id,
      branch_name: branch.branch_name,
      telephone_number: branch.telephone_number,
      mobile_number: branch.mobile_number,
      email: branch.email,
      remarks: branch.remarks || "",
    });
    setModalOpen(true);
  };

  /* ================= SAVE / DELETE ================= */
  const handleSubmit = async () => {
    if (!form.branch_name) {
      alert("Branch name required");
      return;
    }

    let res;
    if (form.id)
      res = await putData(`branch/update/${form.id}`, form);
    else res = await postData("branch/add", form);

    if (res?.status) {
      fetchBranches();
      setModalOpen(false);
    }
  };

  const confirmDelete = async () => {
    const res = await deleteData(
      `branch/delete/${selectedBranch.id}`
    );
    if (res?.status) {
      fetchBranches();
      setDeleteModal(false);
      setSelectedBranch(null);
    }
  };

  /* ================= UI ================= */
  return (
    <div className="min-h-screen bg-slate-50 pt-20 px-4 md:ml-72 md:px-6">

      {/* HEADER */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6">
        <h2 className="text-lg md:text-xl font-bold text-slate-800">
          Branches @ Morgan
        </h2>

        <button
          onClick={openAddModal}
          className="
            inline-flex items-center gap-2
            px-4 py-2.5 bg-indigo-600 text-white text-xs font-semibold
            rounded-xl shadow-sm hover:bg-indigo-700
            transition-all duration-200 active:scale-[0.98]
            w-fit
          "
        >
          <FaPlus /> Add Branch
        </button>
      </div>

      {/* TABLE */}
      <div className="bg-white border border-slate-200/80 rounded-2xl shadow-sm overflow-x-auto">
        <table className="min-w-[900px] w-full text-sm">
          <thead>
            <tr className="bg-slate-50/75 border-b border-slate-250 text-slate-500 font-semibold text-[11px] uppercase tracking-wider">
              <th className="px-6 py-3.5 text-left w-16 whitespace-nowrap">ID</th>
              <th className="px-6 py-3.5 text-left whitespace-nowrap">
                Branch Name
              </th>
              <th className="px-6 py-3.5 text-left whitespace-nowrap">
                Telephone
              </th>
              <th className="px-6 py-3.5 text-left whitespace-nowrap">
                Mobile
              </th>
              <th className="px-6 py-3.5 text-left whitespace-nowrap">
                Email
              </th>
              <th className="px-6 py-3.5 text-center w-32 whitespace-nowrap">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100">
            {branches.length === 0 ? (
              <tr>
                <td
                  colSpan={6}
                  className="px-6 py-6 text-center text-slate-500"
                >
                  No branches found
                </td>
              </tr>
            ) : (
              branches.map((b) => (
                <tr key={b.id} className="hover:bg-slate-50/50 transition-colors duration-150">
                  <td className="px-6 py-4 text-slate-500 whitespace-nowrap">
                    {b.id}
                  </td>
                  <td className="px-6 py-4 font-semibold text-slate-800 whitespace-nowrap">
                    {b.branch_name}
                  </td>
                  <td className="px-6 py-4 text-slate-600 whitespace-nowrap">
                    {b.telephone_number || "-"}
                  </td>
                  <td className="px-6 py-4 text-slate-600 whitespace-nowrap">
                    {b.mobile_number || "-"}
                  </td>
                  <td className="px-6 py-4 text-slate-600 whitespace-nowrap">
                    {b.email || "-"}
                  </td>

                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex justify-center items-center gap-2.5">
                      <button
                        onClick={() => openEditModal(b)}
                        className="p-1.5 rounded-lg text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 transition-all duration-200"
                        title="Edit Branch"
                      >
                        <FaEdit className="text-sm" />
                      </button>

                      <button
                        onClick={() => {
                          setSelectedBranch(b);
                          setDeleteModal(true);
                        }}
                        className="p-1.5 rounded-lg text-slate-400 hover:text-rose-600 hover:bg-rose-50 transition-all duration-200"
                        title="Delete Branch"
                      >
                        <FaTrash className="text-sm" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* ADD / EDIT MODAL */}
      {modalOpen && (
        <div className="fixed inset-0 bg-black/45 backdrop-blur-sm flex justify-center items-center p-4 z-50">
          <div className="bg-white w-full max-w-md p-6 rounded-2xl shadow-xl border border-slate-100">
            <h3 className="text-lg font-bold text-slate-800 mb-4">
              {form.id ? "Edit Branch" : "Add New Branch"}
            </h3>

            <div className="space-y-3.5 text-sm">
              {[
                "branch_name",
                "telephone_number",
                "mobile_number",
                "email",
              ].map((field) => (
                <div key={field}>
                  <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">
                    {field.replace("_", " ")}
                  </label>
                  <input
                    value={form[field]}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        [field]: e.target.value,
                      })
                    }
                    className="w-full border border-slate-200 rounded-xl px-3 py-2 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition-colors"
                  />
                </div>
              ))}

              <div>
                <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">
                  Remarks
                </label>
                <textarea
                  value={form.remarks}
                  onChange={(e) =>
                    setForm({ ...form, remarks: e.target.value })
                  }
                  rows={3}
                  className="w-full border border-slate-200 rounded-xl px-3 py-2 focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition-colors"
                />
              </div>
            </div>

            <div className="flex justify-end gap-2.5 mt-6">
              <button
                onClick={() => setModalOpen(false)}
                className="px-4 py-2 border border-slate-200 rounded-xl hover:bg-slate-50 text-slate-700 font-medium transition-colors"
              >
                Cancel
              </button>

              <button
                onClick={handleSubmit}
                className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-medium transition-colors shadow-sm"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* DELETE MODAL */}
      {deleteModal && (
        <div className="fixed inset-0 bg-black/45 flex justify-center items-center p-4 z-50">
          <div className="bg-white p-6 rounded-2xl shadow-xl border border-slate-100 w-full max-w-sm">
            <h3 className="text-lg font-bold text-slate-800 mb-2">
              Delete Branch
            </h3>
            <p className="text-sm text-slate-500 mb-6">
              Are you sure you want to delete{" "}
              <b className="text-slate-800">{selectedBranch?.branch_name}</b>?
            </p>

            <div className="flex justify-end gap-2.5">
              <button
                onClick={() => setDeleteModal(false)}
                className="px-4 py-2 border border-slate-200 rounded-xl hover:bg-slate-50 text-slate-700 font-medium transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-4 py-2 bg-rose-600 hover:bg-rose-700 text-white rounded-xl font-medium transition-colors"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
